import { IUser } from "../../models/user";

export const UserState: IUser = {
  data: null,
  me: null,
  authenticated: false,
  authenticating: false,
  errors: [],
  otp: null,
};
